export const MinusIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.668 8.66634H3.33464C2.96664 8.66634 2.66797 8.36834 2.66797 7.99967C2.66797 7.63101 2.96664 7.33301 3.33464 7.33301H12.668C13.0366 7.33301 13.3346 7.63101 13.3346 7.99967C13.3346 8.36834 13.0366 8.66634 12.668 8.66634Z" fill="currentColor" />
        </svg>
    )
};